import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { FaBath, FaBed, FaRuler, FaMapMarkerAlt, FaEye } from 'react-icons/fa';

const PropertyCard = ({ inmueble, isGrid = false, isHome = false }) => {

    const navigate = useNavigate();
    const placeholderImage = useMemo(() => {
        const svg = `
      <svg width="400" height="300" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#0D0D0D"/>
        <rect x="20" y="20" width="360" height="260" fill="none" stroke="#D4AF37" stroke-width="2" stroke-dasharray="10,5"/>
        <g transform="translate(200,120)">
          <rect x="-40" y="-30" width="80" height="60" fill="#D4AF37" opacity="0.3"/>
          <circle cx="-15" cy="-10" r="8" fill="#D4AF37"/>
          <path d="M-5,-5 L15,-5 L10,5 L-5,5 Z" fill="#D4AF37"/>
        </g>
        <text x="200" y="200" text-anchor="middle" fill="#D4AF37" font-family="Arial, sans-serif" font-size="18" font-weight="bold">
          Imagen no disponible
        </text>
      </svg>
    `;
        return `data:image/svg+xml;base64,${btoa(svg)}`;
    }, []);

    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(price);
    };


    // const PropertyCard = ({ inmueble, isGrid = false }) => {
    const precio = inmueble.tipo_servicio === 'Venta' ? inmueble.precio_venta : inmueble.precio;
    const precio_venta = inmueble.tipo_servicio === 'Ambos' ? inmueble.precio_venta : -1;
    const imagenPrincipal = inmueble.imagenes && inmueble.imagenes.length > 0
        ? inmueble.imagenes[0].fotourl
        : placeholderImage;

    return (
        <div className={`bg-brand-gold/5 border border-brand-gold/20 rounded-lg overflow-hidden hover:border-brand-gold/40 transition-all duration-300 ${isGrid ? 'flex flex-col h-full' : 'flex flex-col lg:flex-row'}`}>
            {/* Imagen */}
            <div className={`relative ${isGrid ? 'h-48 w-full' : 'lg:w-1/3 aspect-w-16 aspect-h-12 lg:aspect-none'}`}>
                <img
                    src={imagenPrincipal}
                    alt={`${inmueble.clase} en ${inmueble.barrio}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                        e.target.src = placeholderImage;
                    }}
                />

                {/* Badges */}
                <div className="absolute top-4 left-4 flex flex-col gap-2">
                    {inmueble.destacado && (
                        <span className="bg-brand-gold text-brand-black px-3 py-1 rounded-full text-sm font-semibold">
                            Destacado
                        </span>
                    )}
                    <span className="bg-brand-black/80 text-brand-white px-3 py-1 rounded-full text-sm">
                        {inmueble.tipo_servicio}
                    </span>
                </div>
            </div>

            {/* Información */}
            <div className={`p-6 ${isGrid ? 'flex-1 flex flex-col' : 'lg:w-2/3'}`}>
                {/* Precio y tipo */}
                <div className="flex justify-between items-start mb-4">
                    <div>
                        <h3 className="text-2xl font-bold text-brand-gold mb-1">
                            {precio > 0 ? formatPrice(precio) : 'Precio a consultar'} {precio_venta>0?" - "+formatPrice(precio_venta): ""}
                        </h3>
                        <p className="text-brand-gray text-sm">
                            {inmueble.clase} • {inmueble.area}m²
                        </p>
                    </div>
                    <span className="text-brand-gray text-sm">
                        Cod: {inmueble.consecutivo}
                    </span>
                </div>

                {/* Ubicación */}
                <div className="flex items-center text-brand-gray mb-4">
                    <FaMapMarkerAlt className="mr-2 text-brand-gold" size={14} />
                    <span className="text-sm">
                        {inmueble.barrio}, {inmueble.municipio}
                    </span>
                </div>

                {/* Características */}
                <div className="flex items-center gap-6 mb-4 text-brand-gray">
                    {inmueble.alcobas > 0 && (
                        <div className="flex items-center">
                            <FaBed className="mr-2 text-brand-gold" size={14} />
                            <span className="text-sm">{inmueble.alcobas} hab</span>
                        </div>
                    )}
                    {inmueble.baños > 0 && (
                        <div className="flex items-center">
                            <FaBath className="mr-2 text-brand-gold" size={14} />
                            <span className="text-sm">{inmueble.baños} baños</span>
                        </div>
                    )}
                    <div className="flex items-center">
                        <FaRuler className="mr-2 text-brand-gold" size={14} />
                        <span className="text-sm">{inmueble.area}m²</span>
                    </div>
                </div>

                {/* Características adicionales */}
                <div className={`flex flex-wrap gap-2 mb-4 ${isHome ? 'hidden' : ''}`}>
                    {inmueble.ascensor && (
                        <span className="bg-brand-gold/20 text-brand-gold px-2 py-1 rounded text-xs">
                            Ascensor
                        </span>
                    )}
                    {inmueble.piscina && (
                        <span className="bg-brand-gold/20 text-brand-gold px-2 py-1 rounded text-xs">
                            Piscina
                        </span>
                    )}
                    {inmueble.parqueadero && (
                        <span className="bg-brand-gold/20 text-brand-gold px-2 py-1 rounded text-xs">
                            Parqueadero
                        </span>
                    )}
                    {inmueble.unidad_cerrada && (
                        <span className="bg-brand-gold/20 text-brand-gold px-2 py-1 rounded text-xs">
                            Unidad Cerrada
                        </span>
                    )}
                </div>

                {/* Botón de acción */}
                <button
                    onClick={() => navigate(`/inmueble/${inmueble.consecutivo}`)}
                    className={`w-full bg-brand-gold text-brand-black py-3 rounded-lg font-semibold hover:bg-brand-gold/90 transition-colors flex items-center justify-center ${isGrid ? 'mt-auto' : ''}`}
                >
                    <FaEye className="mr-2" size={16} />
                    Ver detalles
                </button>
            </div>
        </div>
    );
};

export default PropertyCard;